import React, { Component, PropTypes } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import $ from 'jquery';
import { bootstrapUI } from 'plugins/bootstrap';
import bindMultirefs from 'plugins/multiref-checkboxes';
import bindComplexMultirefs from 'plugins/complex-checkboxes';

require('plugins/forms');

class DiagnosticForm extends Component {
  constructor(props) {
    super(props);

    this._setContent = this._setContent.bind(this);
    this._generateFormObject = this._generateFormObject.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    return shallowCompare(this, nextProps);
  }

  componentDidMount() {
    this._initForm();

    const initialForm = this._generateFormObject();
    this.setState({ initialForm: initialForm });
  }

  componentDidUpdate(prevProps) {
    const { content, errors } = this.props;

    if (content !== prevProps.content || errors !== prevProps.errors) {
      this._initForm();
    }
  }

  componentWillUpdate(nextProps) {
    const { tab, site, mustSerialize } = this.props;

    if (
      tab !== nextProps.tab ||
      site.id !== nextProps.site.id ||
      mustSerialize !== nextProps.mustSerialize
    ) {
      this._serializeForm();
    }
  }

  _serializeAnnexForm(form) {
    const indexedRefs = $(this._content)
      .find('[name="complexList.complex_refs[].ref"]')
      .map((_, elem) =>
        Object.assign({ index: $(elem).data('index'), value: $(elem).val() })
      )
      .toArray();

    const indexedText1 = $(this._content)
      .find('[name="complexList.complex_refs[].text1"]')
      .map((idx, elem) =>
        Object.assign({ index: $(elem).data('index'), value: $(elem).val() })
      )
      .toArray();

    const indexedText2 = $(this._content)
      .find('[name="complexList.complex_refs[].text2"]')
      .map((idx, elem) =>
        Object.assign({ index: $(elem).data('index'), value: $(elem).val() })
      )
      .toArray();

    const serialized = form.serializeObject();

    return {
      ...serialized,
      'complexList.complex_refs[].ref_values': indexedRefs,
      'complexList.complex_refs[].text1': indexedText1,
      'complexList.complex_refs[].text2': indexedText2,
    };
  }

  _generateFormObject() {
    const { tab } = this.props;
    const form = $(this._content);

    return tab === 'ANNEX_1' || tab === 'ANNEX_2'
      ? this._serializeAnnexForm(form)
      : form.serializeObject();
  }

  _serializeForm() {
    const { tab, onSerialize } = this.props;
    const { initialForm } = this.state;
    const serialized = this._generateFormObject();

    // Json comparing initial form and serialized form to handle dirty form behavior between tab switching
    if (
      initialForm &&
      JSON.stringify(initialForm) === JSON.stringify(serialized)
    ) {
      onSerialize(
        tab,
        {
          ...serialized,
        },
        false
      );
      return;
    } else {
      onSerialize(tab, {
        ...serialized,
      });
    }
  }

  _initForm() {
    const { errors } = this.props;
    const $content = $(this._content);

    bootstrapUI($content);
    bindMultirefs();
    bindComplexMultirefs();

    // Serializing on content changes
    $content
      .find('input, select, textarea')
      .not('.no-trigger')
      .off('change')
      .on('change', evt => {
        this._serializeForm();
      });

    // Reset errors
    $content.find('.field').removeClass('error');

    // Displaying errors
    errors &&
      errors.forEach(e => {
        $content
          .find(`input[name="${e.field}"]`)
          .closest('.field')
          .addClass('error');
      });
  }

  _setContent(ref) {
    this._content = ref;
  }

  render() {
    const { content } = this.props;

    return (
      <form
        ref={this._setContent}
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
    );
  }
}

DiagnosticForm.propTypes = {
  tab: PropTypes.string.isRequired,
  site: PropTypes.object.isRequired,
  content: PropTypes.string,
  errors: PropTypes.array.isRequired,
  mustSerialize: PropTypes.bool.isRequired,
  onSerialize: PropTypes.func.isRequired,
};

export default DiagnosticForm;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/components/DiagnosticForm.js